"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Storybook = exports.FlatButtonSizes = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Text = require("../../components/Text/Text.util");
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _createIcon = _interopRequireDefault(require("../../utils/createIcon"));
var _createPolymorphicComponent = _interopRequireDefault(require("../../utils/createPolymorphicComponent"));
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _getPseudoStyles = _interopRequireDefault(require("../../utils/getPseudoStyles"));
var _pickAndRemoveFromObject = _interopRequireDefault(require("../../utils/pickAndRemoveFromObject"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
var _excluded = ["as", "children", "className", "customColor", "iconLeft", "iconRight", "label", "overrides", "size", "ghost", "primary", "fullWidth", "type"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var common = ["width", "minWidth", "maxWidth", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "gap", "background"].concat(_toConsumableArray(_commonProps.defaultCommonProps));
var vars = (0, _initVars.default)({
  applied: common,
  variables: [{
    key: "buttonCustomColor",
    canHaveColor: true
  }]
});
var FlatButtonSizes = exports.FlatButtonSizes = /*#__PURE__*/function (FlatButtonSizes) {
  FlatButtonSizes["SMALL"] = "small";
  FlatButtonSizes["MEDIUM"] = "medium";
  FlatButtonSizes["LARGE"] = "large";
  return FlatButtonSizes;
}({});
var FlatButton = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _props$as = props.as,
    Element = _props$as === void 0 ? "button" : _props$as,
    children = props.children,
    className = props.className,
    customColor = props.customColor,
    iconLeft = props.iconLeft,
    iconRight = props.iconRight,
    label = props.label,
    _props$overrides = props.overrides,
    overrides = _props$overrides === void 0 ? {} : _props$overrides,
    _props$size = props.size,
    size = _props$size === void 0 ? "medium" : _props$size,
    ghost = props.ghost,
    primary = props.primary,
    fullWidth = props.fullWidth,
    _props$type = props.type,
    type = _props$type === void 0 ? "button" : _props$type,
    otherProps = _objectWithoutProperties(props, _excluded);
  var classes = useStyles(_objectSpread({
    buttonCustomColor: customColor
  }, (0, _pickAndRemoveFromObject.default)(otherProps, common)));
  var content = label !== null && label !== void 0 ? label : children;
  return /*#__PURE__*/_react.default.createElement(Element, _extends({
    ref: ref
  }, otherProps, {
    className: (0, _classnames.default)(classes.variables, classes.root, classes[size], _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, classes.ghost, ghost), classes.primary, primary), classes.fullWidth, fullWidth), classes.iconLeft, iconLeft), classes.iconRight, iconRight), classes.long, typeof content === "string" && content.length > 20), classes.veryLong, typeof content === "string" && content.length > 32), classes.buttonCustomColor, customColor), overrides.root, className),
    type: type
  }), (0, _createIcon.default)(iconLeft), label && /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)(classes.label, overrides.label)
  }, label), children && /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)(classes.label, overrides.label)
  }, children), (0, _createIcon.default)(iconRight));
});
var styles = function styles(theme) {
  return {
    variables: vars.styles,
    root: _objectSpread(_objectSpread(_objectSpread({
      display: "inline-flex",
      alignItems: "center",
      gap: theme.spacing.base,
      outline: "none",
      cursor: "pointer",
      position: "relative",
      userSelect: "none",
      textDecoration: "none",
      margin: "0",
      borderRadius: 2,
      background: "transparent",
      transition: "background 250ms ease-in-out",
      padding: [0, theme.spacing.base * 2],
      textTransform: "uppercase",
      minWidth: theme.spacing.base * 11,
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "transparent",
      fontFamily: theme.typography.fontFamily,
      letterSpacing: theme.typography.letterSpacing,
      color: "var(--color)",
      "--color": theme.colors.baseContrast090
    }, (0, _Text.setTextCssVars)({
      fontSize: theme.typography.fontSize,
      fontWeight: 500
    })), {}, {
      "--lineHeight": "normal",
      "& svg": {
        display: "inline-flex",
        fill: "var(--color)"
      }
    }, (0, _getPseudoStyles.default)({
      hover: {
        backgroundColor: theme.colors.baseContrast020
      }
    })), {}, {
      "&:disabled": {
        pointerEvents: "none",
        borderColor: "transparent",
        "--color": theme.colors.baseContrast040
      }
    }),
    fullWidth: {
      width: "100%",
      minWidth: "100%"
    },
    long: {},
    ghost: _objectSpread(_objectSpread({
      textTransform: "none",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.colors.baseInvariant
    }, (0, _Text.setTextCssVars)({
      fontSize: theme.typography.fontSize + 1
    })), {}, {
      "&:disabled": {
        borderColor: theme.colors.baseContrast030
      }
    }),
    primary: {
      "--color": theme.colors.primary
    },
    label: {
      display: "inline-flex",
      alignSelf: "center",
      justifyContent: "center",
      alignItems: "center",
      pointerEvents: "none",
      margin: [0, "auto"],
      position: "relative"
    },
    small: {
      height: theme.spacing.base * 4,
      "& > svg": {
        height: theme.iconSizes.small,
        width: theme.iconSizes.small,
        minHeight: theme.iconSizes.small,
        minWidth: theme.iconSizes.small
      }
    },
    medium: {
      height: theme.spacing.base * 5,
      "& > svg": {
        height: theme.iconSizes.small + 2,
        width: theme.iconSizes.small + 2,
        minHeight: theme.iconSizes.small + 2,
        minWidth: theme.iconSizes.small + 2
      }
    },
    large: {
      height: theme.spacing.base * 6,
      "& > svg": {
        height: theme.iconSizes.medium,
        width: theme.iconSizes.medium,
        minHeight: theme.iconSizes.medium,
        minWidth: theme.iconSizes.medium
      }
    },
    iconLeft: {
      paddingInlineStart: theme.spacing.base * 1.5
    },
    iconRight: {
      paddingInlineEnd: theme.spacing.base * 1.5
    },
    veryLong: _objectSpread(_objectSpread({}, (0, _Text.setTextCssVars)({
      fontSize: theme.typography.fontSize - 4
    })), {}, {
      padding: [0, theme.spacing.base + 2]
    }),
    buttonCustomColor: {
      color: vars.get("buttonCustomColor"),
      borderColor: vars.get("buttonCustomColor")
    }
  };
};
var useStyles = (0, _createUseStyles.default)(styles, {
  name: "FlatButton"
});
FlatButton.displayName = "FlatButton";
var Storybook = exports.Storybook = FlatButton;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/action-flatbutton--docs
 */
var exportedComponent = (0, _createPolymorphicComponent.default)((0, _defaultProps.default)(FlatButton));
exportedComponent.displayName = "FlatButton";
var _default = exports.default = exportedComponent;